import {Component, OnInit} from '@angular/core';
import {CommonMessagesService} from '../../../../services/common-messages.service';
import {Profile} from "../../../../model/profile";
import {ProfilesService} from "../../../../services/profiles.service";
import {ProfileFilters} from "../../../../model/filters/profile-filters";
import {DialogService} from 'primeng/dynamicdialog';
import {AuthGuard} from "../../../../common/auth-guard.service";
import {TimezoneService} from "../../../../services/timezone.service";
import {TranslocoService} from "@ngneat/transloco";

@Component({
  selector: 'app-profile-list',
  templateUrl: './profile-list.component.html',
  styleUrls: ['./profile-list.component.scss'],
  providers: [DialogService]
})
export class ProfileListComponent implements OnInit {

  public profiles: Profile[];
  public totalProfiles: number;
  public loadingProfiles: boolean;

  public rows: number = 10;
  public first: number = 0;

  public filtersVisible: boolean;
  public currentFilters: ProfileFilters;

  public showCustomDialog: boolean;
  public selectedProfile: Profile;
  public profileOptions: Profile[];

  public availableYearRange: string;
  public rangeDates: Date[];
  public language: string;


  constructor(
    private profilesService: ProfilesService,
    private readonly dialogService: DialogService,
    private commonMessagesService: CommonMessagesService,
    private readonly timezoneService: TimezoneService,
    public authGuard: AuthGuard,
    private i18n: TranslocoService
  ) {
    this.currentFilters = new ProfileFilters();
    this.availableYearRange = this.timezoneService.calcYearRange();
    this.showCustomDialog = false;
  }

  ngOnInit(): void {
    this.language = this.i18n.getActiveLang();
    this.profiles = new Array(this.rows);
  }

  onPageChange(event): void {
    this.loadProfiles(event.first / event.rows, event.rows);
  }

  resetFilters(): void {
    this.currentFilters = new ProfileFilters();
    this.rangeDates = undefined;
  }

  applyFilters(): void {
    this.first = 0;
    if (this.rangeDates) {
      let periodRange: { from: number, until: number };
      this.currentFilters.from = this.rangeDates[0].getTime();
      if (this.rangeDates.length == 1 || this.rangeDates[1] == null) {
        periodRange = this.timezoneService.timestampRangeFromCalendarData([this.rangeDates[0], this.rangeDates[0]]);
      } else {
        periodRange = this.timezoneService.timestampRangeFromCalendarData([this.rangeDates[0], this.rangeDates[1]]);
      }
      this.currentFilters.from = periodRange.from;
      this.currentFilters.until = periodRange.until;
    } else if (this.currentFilters.from) {
      this.currentFilters.from = null;
      this.currentFilters.until = null;
    }
    this.loadProfiles(this.first / this.rows, this.rows);
  }

  confirmAndDelete(profile: Profile): void {
    this.profilesService.getUsersWithProfile(profile.profileUuid).subscribe(response => {
      if (response.users.length == 0) {
        this.commonMessagesService.showDeleteRequestConfirmation(() => {
          this.deleteProfile(profile.profileUuid);
        });
      } else {
        this.openDeleteProfileDialog(profile);
      }
    })
  }

  private deleteProfile(profileUuid: string): void {
    this.profilesService.deleteProfile(profileUuid).toPromise().then(() => {
      this.deleteSuccess();
    }, error => {
      this.commonMessagesService.showErrorWhileDeletingMessage(error.status);
    });
  }

  private openDeleteProfileDialog(profile: Profile): void {
    this.selectedProfile = profile;
    this.profileOptions = this.profiles.filter(p => p.profileUuid != profile.profileUuid);
    this.showCustomDialog = true;
  }

  private deleteSuccess(): void {
    this.commonMessagesService.showSuccessfullyDeletedMessage();
    this.loadProfiles(this.first / this.rows, this.rows);
  }

  trimFieldsForm(filters: ProfileFilters): void {
    Object.keys(filters).forEach((key) => {
      if (filters[key] !== undefined && typeof filters[key] === 'string') {
        filters[key] = filters[key].trim();
      }
    });
  }

  private loadProfiles(offset?: number, limit?: number): void {
    this.loadingProfiles = true;
    this.profiles = new Array(this.rows);
    this.trimFieldsForm(this.currentFilters);
    this.profilesService.getProfiles(offset, limit, this.currentFilters)
      .subscribe(response => {
        this.profiles = response.data.content;
        this.totalProfiles = response.data.totalElements;
        this.loadingProfiles = false;
      });
  }

  onClose(response: any): void {
    this.showCustomDialog = false;
    if (response.success) {
      this.deleteSuccess();
    }
  }

}
